module.exports = __webpack_public_path__ + "static/media/lastgoalassister.4b6e9940.jpg";